import { z } from "zod";
import { type SavedBenchmarks } from ".";
import { normaliseSpacing } from "@/lib/utils/formatting";

export const createBenchmarkFormSchema = ({
  benchmarks,
  existingBenchmarkName,
}: {
  benchmarks: SavedBenchmarks | undefined;
  existingBenchmarkName?: string;
}) =>
  z.object({
    benchmarkName: z
      .string()
      .min(1, {
        message: "Name must be at least 2 characters.",
      })
      .max(25, {
        message: "Name must be at most 25 characters.",
      })
      .transform(normaliseSpacing)
      .refine(
        (name) => {
          // If editing an existing benchmark, allow the same name
          if (existingBenchmarkName && name.toLowerCase() === existingBenchmarkName.toLowerCase()) {
            return true;
          }

          // Check if name exists in other benchmarks
          return (
            !benchmarks ||
            !Object.keys(benchmarks).some((existingName) => existingName.toLowerCase() === name.toLowerCase())
          );
        },
        {
          message: "A benchmark with this name already exists",
        },
      ),
  });
